import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["produto", "instituicao", "motivo", "submit"]
  static values = { cartao: String }

  produtoChanged() {
    const produtoId = this.produtoTarget.value
    if (!produtoId) {
      this.instituicaoTarget.disabled = true
      this.instituicaoTarget.innerHTML = '<option value="">-- Selecione a Instituição --</option>'
      this._disableSubmit()
      return
    }

    const url = `/aa/solicitacoes/instituicoes?cartao=${this.cartaoValue}&produto_id=${produtoId}`
    fetch(url, { headers: { "Accept": "application/json" } })
      .then(response => response.json())
      .then(data => {
        this.instituicaoTarget.innerHTML = '<option value="">-- Selecione a Instituição --</option>'
        data.forEach(item => {
          const option = new Option(`${item.razao_social} (${item.sigla})`, item.id)
          this.instituicaoTarget.add(option)
        })
        this.instituicaoTarget.disabled = false
        this._disableSubmit()
      })
  }

  instituicaoChanged() {
    const hasValue = !!this.instituicaoTarget.value
    this.motivoTarget.disabled = !hasValue
    this.submitTarget.disabled = !hasValue
  }

  _disableSubmit() {
    this.motivoTarget.disabled = true
    this.submitTarget.disabled = true
  }
}
